class SceneStatusController {
  constructor ($scope, $interval, SceneService) {
    'ngInject'

    this._$scope = $scope
    this._$interval = $interval
    this._SceneService = SceneService
    this.isCollapsed = false
    this.isOnline = false
  }

  $onInit () {
    this.unsubscribe = this._SceneService.subscribeToId(this.id, scene => {
      this.scene = scene
      this._updateOnlineStatus()
    })

    // Re-evaluate online status every 10 seconds (heartbeat is 15s, so 30s threshold)
    this._statusInterval = this._$interval(() => this._updateOnlineStatus(), 10000)

    this._$scope.$on('$destroy', () => {
      this.unsubscribe()
      if (this._statusInterval) {
        this._$interval.cancel(this._statusInterval)
      }
    })
  }

  _updateOnlineStatus () {
    if (!this.scene || !this.scene.lastSeen) {
      this.isOnline = false
      return
    }
    const now = Math.floor(Date.now() / 1000)
    // Consider offline if no heartbeat in 45 seconds (3 missed heartbeats)
    this.isOnline = (now - this.scene.lastSeen) < 45
  }
}

export default {
  bindings: {
    id: '<'
  },
  controller: SceneStatusController,
  template: require('./scene-status.component.html').default
}
